import ArticleNextPage, { getStaticPaths } from 'src/pages/[param]/[month]/[day]/[slug]';
import { Microsites } from 'constants/constants';
import { getArticleStaticProps } from 'utils/miscUtils/getArticleStaticProps';
import type { GetStaticProps } from 'next';

export default ArticleNextPage;

export const getStaticProps: GetStaticProps = async (context) => {
  return getArticleStaticProps(context, { microsite: Microsites.Asia });
};

export { getStaticPaths };
